import styled, { css } from 'styled-components';
import { device } from '../../constants';

export const WhatsAppButtonDesktop = styled.a`
  ${({ theme }) => css`
    background-color: ${theme.colors['branding-02']};

    &:hover {
      background-color: #568F1E;
      color: ${theme.colors['neutral-01']};
    }
  `}

  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 236px;
  width: 40px;
 
  border-radius: 8px 0 0 8px;
  display: none;
  align-items: center;
  text-decoration: none;
  font-family: 'Hind Madurai', sans-serif;
  font-size: 16px;
  line-height: 32px;
  font-weight: 500;
  padding: 8px;
  z-index: 999;
  transition: background-color 0.3s ease;

  span {
    color: ${({ theme }) => theme.colors['neutral-01']};
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    letter-spacing: 1.2px;
  }

  img {
    margin-top: 10px;
    width: 20px;
    height: 20px;
    transform: rotate(-90deg);
  }

  @media ${device.laptop} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const WhatsAppButtonMobile = styled.a`
  position: fixed;
  right: 24px;
  bottom: 40px;
  width: 56px;
  height: 56px;
  background-color: ${({ theme }) => theme.colors['branding-02']};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #568F1E;
  }

  img {
    width: 24px;
    height: 24px;
  }

  @media ${device.laptop} {
    display: none;
  }
`; 